class CollectionListGrid extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll(".cl_card"));
    if (!this.cards.length) return;

    this.setupTouchFeedback();
  }

  setupTouchFeedback() {
    if (!("ontouchstart" in window)) return;

    this.cards.forEach((card) => {
      const link = card.querySelector(".cl_card_link");
      if (!link) return;

      link.addEventListener("touchstart", () => link.classList.add("is-active"), {
        passive: true,
      });
      link.addEventListener("touchend", () => link.classList.remove("is-active"), {
        passive: true,
      });
    });
  }
}

customElements.define("collection-list-grid", CollectionListGrid);
